module.exports = __webpack_public_path__ + "static/media/arrow-circle-down.80972e66.svg";